import React from 'react';
import { VideoTemplatesPageComponent } from '@bingads-webui-campaign-react/ads-studio-app-components';

export const VideoTemplatesPage = props => <VideoTemplatesPageComponent {...props} />;
